var exports = {
  "k": "xa15a2ab7--6fbce0--container",
  "i": "xa15a2ab7--6fbce0--wrapper",
};

module.exports = exports;
